import React from 'react';
import PropTypes from 'prop-types';

import Input from '../../../core/Input';
import { ArrowLeft } from '../../../../../assets/images/index';
import { EXPERIENCE } from '../../../../constants/literals/modals';

import {
  StyledLabel,
  LabelBlock,
  StyledBoxInputEducation,
  StyledBoxModuleAlignTop,
  StyledOrderItem,
  StyledCheckbox,
  StyledLine,
  StyledWrapperRow,
  StyledWrapperCell
} from './style';

import {
  WrapperCollapsed,
  StyledIconDrop,
  StyledDropdownInputMonths,
  StyledDropdownInputYears,
  RangeDates,
  ItemRangeDates
} from './styleEducation';

const ModExperienceItem = ({
  companyName,
  checkedCurrentWork,
  expanded,
  listMonths,
  listYears,
  onChangeCheckbox,
  onChangeInputCompany,
  onChangeInputDescription,
  onChangeInputPosition,
  onClickDown,
  onClickExpand,
  onClickUp,
  onSelectFromMonth,
  onSelectFromYear,
  onSelectUntilMonth,
  onSelectUntilYear,
  order,
  selectedFromMonth,
  selectedFromYear,
  selectedUntilMonth,
  selectedUntilYear,
  summary,
  title
}) => (
  <StyledBoxModuleAlignTop>
    <StyledOrderItem
      order={order}
      onClickDown={onClickDown}
      onClickUp={onClickUp}
    />
    <StyledLine />
    <StyledBoxInputEducation>
      <StyledIconDrop
        svg={ArrowLeft}
        size="s"
        hover
        onClick={onClickExpand}
        expanded={expanded}
      />
      <StyledWrapperRow>
        <StyledWrapperCell>
          <StyledLabel>{EXPERIENCE.COMPANY_NAME}</StyledLabel>
          <Input onChange={onChangeInputCompany} value={companyName} />
        </StyledWrapperCell>
        <StyledWrapperCell>
          <StyledLabel>{EXPERIENCE.POSITION}</StyledLabel>
          <Input onChange={onChangeInputPosition} value={title} />
        </StyledWrapperCell>
      </StyledWrapperRow>

      <WrapperCollapsed expanded={expanded}>
        <StyledLabel>{EXPERIENCE.DESCRIPTION}</StyledLabel>
        <Input
          multiline
          rows={4}
          onChange={onChangeInputDescription}
          value={summary}
        />
        <RangeDates>
          <ItemRangeDates>
            <LabelBlock id="fromRange">{EXPERIENCE.FROM}</LabelBlock>
            <StyledDropdownInputMonths
              list={listMonths}
              selected={selectedFromMonth}
              ariaLabelledby="fromRange"
              onSelect={onSelectFromMonth}
              label={selectedFromMonth}
            />
            <StyledDropdownInputYears
              list={listYears}
              selected={selectedFromYear}
              ariaLabelledby="fromRange"
              onSelect={onSelectFromYear}
              label={selectedFromYear}
            />
          </ItemRangeDates>
          <ItemRangeDates>
            <LabelBlock disabled={checkedCurrentWork} id="untilRange">
              {EXPERIENCE.UNTIL}
            </LabelBlock>
            <StyledDropdownInputMonths
              disabled={checkedCurrentWork}
              list={listMonths}
              selected={selectedUntilMonth}
              onSelect={onSelectUntilMonth}
              ariaLabelledby="untilRange"
              label={selectedFromMonth}
            />
            <StyledDropdownInputYears
              disabled={checkedCurrentWork}
              list={listYears}
              selected={selectedUntilYear}
              onSelect={onSelectUntilYear}
              ariaLabelledby="untilRange"
              label={selectedFromYear}
            />
          </ItemRangeDates>
        </RangeDates>
        <StyledCheckbox
          checked={checkedCurrentWork}
          onChange={onChangeCheckbox}
          label={EXPERIENCE.CURRENT_WORKER}
        />
      </WrapperCollapsed>
    </StyledBoxInputEducation>
  </StyledBoxModuleAlignTop>
);

ModExperienceItem.propTypes = {
  companyName: PropTypes.string,
  checkedCurrentWork: PropTypes.bool,
  expanded: PropTypes.bool,
  listMonths: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)],
      id: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)]
    })
  ),
  listYears: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)],
      id: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)]
    })
  ),
  onChangeCheckbox: PropTypes.func,
  onChangeInputCompany: PropTypes.func,
  onChangeInputDescription: PropTypes.func,
  onChangeInputPosition: PropTypes.func,
  onClickDown: PropTypes.func,
  onClickExpand: PropTypes.func,
  onClickUp: PropTypes.func,
  onSelectFromMonth: PropTypes.func,
  onSelectFromYear: PropTypes.func,
  onSelectUntilMonth: PropTypes.func,
  onSelectUntilYear: PropTypes.func,
  order: PropTypes.number,
  selectedFromMonth: PropTypes.string,
  selectedFromYear: PropTypes.string,
  selectedUntilMonth: PropTypes.string,
  selectedUntilYear: PropTypes.string,
  summary: PropTypes.string,
  title: PropTypes.string
};

ModExperienceItem.defaultProps = {
  companyName: '',
  expanded: false,
  order: 0,
  selectedFromMonth: 'Mes',
  selectedFromYear: 'Año',
  selectedUntilMonth: 'Mes',
  selectedUntilYear: 'Año',
  summary: '',
  title: ''
};

export default ModExperienceItem;
